import { render, staticRenderFns } from "./formInfo.vue?vue&type=template&id=6e6eee1c&scoped=true&"
import script from "./formInfo.vue?vue&type=script&lang=js&"
export * from "./formInfo.vue?vue&type=script&lang=js&"
import style0 from "./formInfo.vue?vue&type=style&index=0&id=6e6eee1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6eee1c",
  null
  
)

export default component.exports